import React from 'react'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'

import LoadingScreen from '../screens/LoadingScreen'
import LinkingConfiguration from './LinkingConfiguration'
import RootNavigator from './navigators/RootNavigator'
import useCurrentUserLoader from '../hooks/useCurrentUserLoader'
import { NavigationContainer, createAppHistory } from './core'

// Keep react-router v6 behaviour (and don't warn about the v7 changes).
const ROUTER_FUTURE = { v7_startTransition: false, v7_relativeSplatPath: false }

export default function Navigation() {
  const { firebaseInitialized } = useCurrentUserLoader()
  const [history] = React.useState(createAppHistory)

  if (!firebaseInitialized) {
    return <LoadingScreen />
  }

  return (
    <HistoryRouter history={history} future={ROUTER_FUTURE}>
      <NavigationContainer history={history} linking={LinkingConfiguration}>
        <RootNavigator />
      </NavigationContainer>
    </HistoryRouter>
  )
}
